const presentOutcome = (outcome, opts = {}) => ({
  ...outcome,
  clickSource: 'featured-widget',
  desc: opts.layout === 'horizontal' ? outcome.shD : outcome.desc,
});

export default presentOutcome;

export const presentOutcomes = (outcomes, opts = {}) => outcomes
  .map((outcome) => presentOutcome(outcome, opts));
